import { Card } from 'flowbite-react';
import React from 'react';
import * as styles from './welcomeCard.styles';
import { useNavigate } from 'react-router-dom';

interface WelcomeCardProps {
  className?: string;
  title: string;
  comment: string;
  buttonText: string;
  flexDirection?: 'row' | 'col';
  route: string;
  backgroundImage?: string;
  buttonBgColor?: string; // Add this prop for button background color
  buttonTextColor?: string; // Add this prop for button text color
  handleClick?:()=>void
}

const WelcomeCard = ({
  flexDirection = 'row',
  title,
  comment,
  buttonText,
  route,
  backgroundImage,
  handleClick,
  buttonBgColor = 'bg-white hover:bg-gray-100 ', 
  buttonTextColor = 'text-gray-700', 
}: WelcomeCardProps) => {
  const navigate = useNavigate();

  return (
    <Card
      className={`${styles.card} ${backgroundImage ? styles.backgroundImage : ''}`}
      style={
        backgroundImage
          ? { backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }
          : {}
      }
    >
      {flexDirection === 'row' ? (
        <div>
          <div className={styles.rowStyles}>
            <p className={styles.title}>{title}</p>
            <button
              className={`${styles.button} ${buttonBgColor} ${buttonTextColor}`}
              onClick={handleClick ? () => handleClick() :() => navigate(route)}
            >
              {buttonText}
            </button>
          </div>
          <div>
            <p className={styles.comment}>{comment}</p>
          </div>
        </div>
      ) : (
        <div>
          <div className={styles.columnStyles}>
            <p className={styles.title}>{title}</p>
            <p className={styles.comment}>{comment}</p>
          </div>
          <div className="mt-4">
            <button
              className={`${styles.button} ${buttonBgColor} ${buttonTextColor}`}
              onClick={handleClick ? () => handleClick() :() => navigate(route)}
            >
              {buttonText}
            </button>
          </div>
        </div>
      )}
    </Card>
  );
};

export default WelcomeCard;
